<template>
  <div>
    <div id="div0">
    <div id="divLeft">
      <slot name="calendarTop"></slot>
    </div>
    <div id="div1">
      <button @click="start=moment(start).add(-1, 'month').format('yyyy-MM-DD');date=start"><svg width="11" height="25" viewBox="0 0 11 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10.9999 1.32828C10.9999 1.59793 10.9169 1.872 10.7419 2.10629L3.78757 11.5264C3.35685 12.1077 3.35685 12.8923 3.78757 13.4736L10.7419 22.8937C11.1793 23.4861 11.047 24.3149 10.4458 24.7459C9.84456 25.1769 9.00331 25.0465 8.56586 24.4541L1.61154 15.0341C0.492117 13.5178 0.492117 11.4822 1.61154 9.96595L8.56586 0.545849C9.00331 -0.0464977 9.84456 -0.176903 10.4458 0.254097C10.8069 0.512695 10.9999 0.917171 10.9999 1.32828Z" fill="var(--color-pri)"/>
      </svg>
      </button>
      <div>{{moment(start).year()}} , {{moment(start).format('M月')}} </div>
      <!-- <div class="absOptions">
        <div class="absOption">
          <div v-for="ym0 in ym" :key="`ym-${ym0}`">{{moment(ym0).year()}} , {{moment(ym0).format('M月')}}</div>
        </div>
      </div> -->
      <button @click="start=moment(start).add(1, 'month').format('yyyy-MM-DD');date=start"><svg width="11" height="25" viewBox="0 0 11 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.68732e-06 23.6717C4.69911e-06 23.4021 0.0830087 23.128 0.257988 22.8937L7.21231 13.4736C7.64303 12.8923 7.64303 12.1077 7.21231 11.5264L0.257989 2.10629C-0.179461 1.51394 -0.0471039 0.685096 0.554109 0.254097C1.15532 -0.176902 1.99657 -0.046497 2.43402 0.545851L9.38834 9.96595C10.5078 11.4822 10.5078 13.5178 9.38834 15.0341L2.43402 24.4542C1.99657 25.0465 1.15532 25.1769 0.554108 24.7459C0.192931 24.4873 4.66935e-06 24.0828 4.68732e-06 23.6717Z" fill="var(--color-pri)"/>
      </svg>
      </button>
      <!-- <Btn :text="'自訂時間'" :bg="'var(--color-pri)'" class="settimebtn" @click="calc=true"/> -->
    </div>
    </div>
    <div class="celendar" :style="{marginTop: '21px'}">
      <div v-for="i in 7" :key="`wdy-${i}`" class="wdy">週{{wdy[i-1]}}</div>
      <div class="day pass" v-for="i in startWdy" :key="`pass-${i}`"></div>
      <div class="day" v-for="i in duration+1" :key="`day-${i}`" @click="$emit('datechange', moment(start).add(i - 1, 'day').format('yyyy-MM-DD'))"
      :class="[
        date===moment(start).add(i - 1, 'day').format('yyyy-MM-DD')?'selected':'',
        (dateClosed||[]).includes(moment(start).add(i - 1, 'day').format('yyyy-MM-DD'))?'close':'']">
        <div :class="[
          holidays.includes(moment(start).add(i - 1, 'day').format('yyyy-MM-DD')) ? 'holiday' : '',
          moment(start).add(i - 1, 'day').weekday() === 0 ? 'weekend' : '',
          moment(start).add(i - 1, 'day').weekday() === 6 ? 'weekend' : ''
          ]">{{i}}</div>
        <slot :item="i" :d="moment(start).add(i - 1, 'day').format('yyyy-MM-DD')"></slot>
      </div>
      <div class="day future" v-for="i in endWdy" :key="`future-${i}`"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['startDate', 'dateSelect', 'dateClosed', 'holidays'],
  data () {
    return {
      wdy: ['一', '二', '三', '四', '五', '六', '日'],
      start: this.moment().startOf('month').format('yyyy-MM-DD'),
      date: this.moment().startOf('month').format('yyyy-MM-DD'),
      y: this.moment().year()
    }
  },
  computed: {
    ym () {
      return Array(12).fill('a').map((e, i) => {
        return this.moment().set('year', this.y).set('month', i).startOf('month').format('yyyy-MM-DD')
      })
    },
    startWdy () {
      return (this.moment(this.start).weekday() + 6) % 7
    },
    endWdy () {
      return 7 - ((this.moment(this.start).endOf('month').weekday() + 6) % 7 + 1)
    },
    duration () {
      return this.moment(this.start).endOf('month').diff(this.moment(this.start), 'day')
    }
  },
  watch: {
    startDate () {
      this.start = this.moment(this.startDate).startOf('month').format('yyyy-MM-DD')
    },
    dateSelect: {
      handler () {
        this.date = this.dateSelect
      },
      immediate: true
    },
    start () {
      this.$emit('monthchange', this.start)
    },
    date () {
      this.$emit('datechange', this.date)
    }
  }

}
</script>

<style lang="scss" scoped>
.absOptions {
  position: relative;
  &>div:nth-child(1) {
    height: 1.5em;
  }
  .absOption {
    position: absolute;
    width: 100%;
    top: 150%;
    z-index: 30;
    background-color: #fff;
    &>div{
      height: 1.5em;
    }
    &>div:hover{
      background-color: var(--color-infobox);
    }
  }
}

.celendar {
  max-height: calc(100vh - 195px);
  padding-inline: 5px;
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  border-radius: 5px;
  overflow: auto;
  padding-bottom: 20px;
  box-sizing: border-box;
  &>div{
    flex:1;
  }
  .wdy {
    background-color: var(--color-pri);
    color: #FFFFFF;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 24px;
    line-height: 27px;
    text-align: center;
    letter-spacing: 0.1em;
    &:nth-child(1) {
      border-radius: 5px 0 0 0;
    }
    &:nth-child(7) {
      border-radius:  0 5px 0 0;
    }
  }
  .day {
    position: relative;
    min-height: 100px;
    min-height: 147px;
    border-right: 1px solid #DADADA;
    border-bottom: 1px solid #DADADA;
    &:nth-of-type(7n-6) {
      border-left: 1px solid #DADADA;
    }
    &>div:nth-child(1) {
      font-weight: 500;
      font-size: 18px;
      line-height: 27px;
      text-align: start;
      padding-inline: .5em;
      letter-spacing: 0.1em;
      color: var(--color-pri);
      padding-block: 10px;
      &.holiday {
        color: var(--highlight);
        font-weight: 900;
      }
      &.weekend {
        color: var(--highlight);
        font-weight: 900;
      }
    }
    &.selected {
      background-color: var(--color-bar);
    }
    &.close {
      background-color: #E9E9E9;
    }
  }
}
#div0 {
  display: flex;
  align-items: center;
  gap: 40px;
  height: 40px;
}
#divLeft {
  width: -webkit-fill-available;
}
#div1{
  width: 400px;
  padding-inline: 20px;
  margin-left: auto;
  position: relative;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  &>div{
    min-width: 290px;
    font-weight: 500;
    font-size: 24px;
    line-height: 24px;
    text-align: center;
    letter-spacing: 0.1em;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-pri);
  }
  button {
    background-color: transparent;
  }
}
</style>
